import apiClient from '../apiClient';

export const getExtractionFieldsByRulesetType = (rulesetTypeId) => {
  return apiClient.get(`/extraction-fields/ruleset/${rulesetTypeId}`);
};

export const getRulesetTypes = () => {
  return apiClient.get('/ruleset-types');
};

export const getRulesetTypesByCustomer = (customerId) => {
  return apiClient.get(`/ruleset-types/customer/${customerId}`);
};

export const getRulesetType = (id) => {
  return apiClient.get(`/ruleset-types/${id}`);
};

export const createRulesetType = (rulesetData) => {
  return apiClient.post('/ruleset-types', rulesetData);
};

export const updateRulesetType = (id, rulesetData) => {
  return apiClient.put(`/ruleset-types/${id}`, rulesetData);
};

export const deleteRulesetType = (id) => {
  return apiClient.delete(`/ruleset-types/${id}`);
};

export const checkRulesetNameExists = (customerId, name, excludeId = null) => {
  const params = new URLSearchParams({ customerId, name });
  if (excludeId) {
    params.append('excludeId', excludeId);
  }
  return apiClient.get(`/ruleset-types/check-name?${params}`);
};